import React from "react";
import { Helmet } from "react-helmet-async";
import copy from "../lib/copy";

const Seo = ({ title, description }) => {
  const full = title ? `${title} · ${copy.brand}` : `${copy.brand} — ${copy.positioning}`;
  const d = description || copy.blurb;
  return (
    <Helmet>
      <title>{full}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={full} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default Seo;
